import { AssigneType } from './interfaces';

export const assigneViews = {
  event: {
    searchText: 'searchEvent',
  },
  template: {
    searchText: 'searchTemplate',
  },
};

export const ASSIGN_PLAYLIST_MENU = [
  { name: 'events', key: AssigneType.event },
  { name: 'templates', key: AssigneType.template },
  { name: 'favoriteSections_plural', key: AssigneType.favoriteSections },
];

export const DROP_SEARCH_Q_STEPS = [AssigneType.eventSections, AssigneType.templateSections];
